// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"290":"94716452","839":"0b5570f8"}[chunkId] + ".chunk.js";
};